export default __webpack_public_path__ + "static/media/pic1.a7317c67.jpg";